const pt = {
    actionAlready: "Ainda não registrado? Faça login",
    actionExit: "Sair",
    actionLogin: "FAÇA LOGIN",
    actionRegister: "CADASTRE-SE",
    actionSave: "SALVAR",
    actionStart: "COMEÇAR",
    actionContinue: "CONTINUAR",
    actionReset: "REINICIAR A AVALIAÇÃO",
    actionDoDiagnost: "MOSTRAR DIAGNÓSTICO",
    actionYes: "Sim",
    actionNo: "Não",
    actionNext: "PRÓXIMO",
    actionBusinessCase: "MOSTRAR BOAS PRÁTICAS DA EMPRESA",
    actionBusinessCases: "MOSTRAR BOAS PRÁTICAS DAS EMPRESAS",
    actionOpenUrl: "ABRIR URL",
    actionFilter: "FILTRAR",

    /** HOME */
    msgHomeTitleOne: "Meça e aumente o nível de maturidade circular da sua empresa de móveis",
    msgHomeSubTitle: "A Ferramenta Online FurnCIRCLE avalia o progresso da sua empresa em direção à maturidade circular com base nas estratégias de design circular implementadas",

    msgHomeSection2: "Os requisitos de circularidade estão se expandindo.</br>Você está pronto?",
    msgHomeSection2Text: "<ul style='padding-left: 20px'><li>Responda às perguntas sobre as estratégias de design circular atualmente implementadas em sua empresa.</li><li>Obtenha o índice de maturidade circular de sua empresa.</li><li>Identifique estratégias de design e boas práticas das empresas para levar sua empresa ao próximo nível.</li><li>Aprenda com as boas práticas de empresas reais para continuar melhorando o nível de maturidade circular da sua empresa.</li></ul>",
    msgHomeSection3: "Parceiros",
    msgHomeSection2Btn: "Comece sua avaliação",
    msgHomeSection3Btn: "CONTATAR",

    /** HEADER */
    msgHeader1: "Estratégias de design circular e boas práticas",
    msgHeader4: "Login",

    /** DRAWER */
    msgCompany: "EMPRESA",
    msgDrawer1: "1. Responder",
    msgDrawer2: "2. Avaliar",
    msgDrawer3: "3. Melhorar",
    msgDrawer4: "Coleção de Estratégias",
    msgDrawer6: "Configurações",
    msgDrawer7: "Sair",

    /** LOGIN */
    msgWelcome: "Bem-vindo",
    msgWelcomeSubtitle: "Por favor, faça login para continuar",

    /** REGISTER */
    msgGetStarted: "Começar",
    msgGetStartedSubtitle: "Esta ferramenta de autoavaliação é gratuita e confidencial",

    msgFirstname: "Primeiro Nome",
    msgLastname: "Sobrenome",
    msgEmail: "Email",
    msgPassword: "Senha",
    msgConfirmPassword: "Confirmar senha",
    msgCompanyUser: "Empresa ou nome de usuário",

    msgNotRegister: "Ainda não registrado? <b>Criar uma conta aqui</b>",
    msgAlreadyRegister: "Já registrado? <b>Faça login aqui</b>",

    /** HOME TOOL */
    msgClickImage: "Clique para expandir o modelo linear versus circular.",

    msgArea: "ÁREA",
    msgProgress: "QUESTÕES RESPONDIDAS",

    msgAssessmentAreas: "Estratégias de Design Circular e Ciclo de Vida do Produto",
    msgAssessmentDesc: "As estratégias de design circular são aplicadas durante a fase de design e desenvolvimento de produtos, embora seu impacto (positivo) possa ocorrer em uma ou mais fases posteriores do ciclo de vida do produto. Portanto, uma maneira de classificar as estratégias de design circular é de acordo com a fase do ciclo de vida impactada: design, recursos materiais, produção, distribuição, uso e fim de vida.<br/><br/><span style=\"font-weight:bold; font-size:16px;\">Por favor, responda todas as perguntas para cada bloco ou fase do ciclo de vida, determine seu nível de maturidade circular e planeje sua melhoria e transição para uma economia mais circular!</span>",

    msgAssessment: "Avaliação FurnCIRCLE",
    msgNotApply: "Marque todas as respostas que se aplicam ao desempenho circular atual da sua empresa. As respostas são salvas automaticamente.",
    msgMarkImportant: "Marcar como importante",
    msgComment: "Comentário",
    msgCommentHolder: "Você pode escrever aqui qualquer informação relacionada ou seus próprios comentários.",

    /** ANSWER */
    msgPerformance: "Relatório de Avaliação",
    msgPerformanceSubtitle: "Confira o índice de maturidade circular de sua empresa e de cada fase do ciclo de vida dos seus produtos.",
    msgCompanyLevel: "Índice de maturidade circular da sua empresa (0%-100%)",
    msgBlockArea: "FASE DO CICLO DE VIDA",
    msgBlockValues: "VALORES",

    /** ASSESS */
    msgImprovement: "Relatório de Melhoria",
    msgImprovementMainSubtitle: "Saiba o que você pode fazer para melhorar continuamente a circularidade de sua empresa. Conheça estratégias de design e boas práticas de empresas para levar sua empresa ao próximo nível.</br></br>Fases do ciclo de vida e estratégias de design circular com um rótulo/círculo “vermelho” têm um nível de desempenho igual ou inferior a 25% de seu valor máximo e, portanto, podem ser consideradas uma prioridade para melhorar a circularidade da empresa. Fases ou estratégias com um rótulo/círculo “laranja” têm um nível de desempenho superior a 25% e inferior ou igual a 75%, sendo também importante abordar a melhoria delas. Fases ou estratégias com um rótulo/círculo “verde” têm um nível de desempenho superior a 75% e, portanto, são menos prioritárias para melhoria.",
    msgImprovementSubtitle: "Saiba o que você pode fazer para melhorar continuamente a circularidade de sua empresa. Conheça estratégias de design e boas práticas de empresas para levar sua empresa ao próximo nível.",
    msgLifecyclePhases: "Fases do ciclo de vida",
    msgLifecycleIndex: "Índice de circularidade da fase",
    msgActionsToImplement: "Ações a implementar:",
    msgBaselineScore: "Minha pontuação inicial",
    msgBusinessCaseEmpty: "Parabéns! Você já implementou as principais estratégias incluídas nesta categoria",

    msgCat1: "ECONÔMICO E ORGANIZACIONAL",
    msgCat2: "SOCIAL",
    msgCat3: "AMBIENTAL",

    /** STRATEGIES COLLECTION */
    msgStrategiesSubtitle: "Explore e navegue pela coleção completa de estratégias de design circular e boas práticas das empresas do projeto FurnCIRCLE.",
    msgLifecyclePhase: "Fase do ciclo de vida",
    msgDifficulty: "Dificuldade de Implementação",
    msgBusinessDynamics: "Geração ou Entrega de Valor",
    msgBusinessFactors: "Proposta de Valor / Custos / Benefícios",

    /** SETTINGS */
    msgUserInfo: "Informações do usuário",
    msgUserCredentials: "Credenciais do usuário",

    /** MODAL */
    msgAreSure: "Tem certeza?",

    msgSuccess: "Dados atualizados com sucesso",
    msgDeleteSuccess: "Dados excluídos com sucesso",

    /** ALT TEXT */
    msgSaveCommentAlt: "Salve o “Comentário”. Não é necessário salvar as respostas das perguntas; elas são salvas automaticamente.",
    msgDifficultyAlt: "Este rótulo indica a dificuldade de implementar a estratégia de design circular.",
    msgBusinessBlockAlt: "Este rótulo indica qual bloco de negócios do modelo CANVAS (Geração de Valor ou Entrega de Valor) é afetado pela implementação da estratégia de design circular.",
    msgImpactBlockAlt: "Este rótulo indica qual bloco de impacto do modelo CANVAS (Custos, Benefícios ou Proposta de Valor) é afetado pela implementação da estratégia de design circular.",

    /** ERROR */
    errorOblData: "Preencha todos os campos obrigatórios",
    errorEmailFormat: "Erro no formato de email",
    errorUserIncorrect: "Email/senha incorretos",
    errorSend: "Erro de comunicação, por favor aguarde e tente novamente mais tarde",
    errorLength: "O número de caracteres foi excedido",
    errorPassSame: "As senhas não são iguais",

    /** RECOVERY PASS */
    msgRecoveryPassword: "Recuperação de senha",
    msgRecoveryPasswordSubtitle: "Por favor, insira seu endereço de e-mail para receber um código de redefinição de senha.",
    msgCode: "Código",
    msgNewPassword: "Nova senha",
    actionRequestCode: "SOLICITAR CÓDIGO",
    actionUpdate: "ATUALIZAR",
    actionBack: "VOLTAR",
    msgForgetPassword: "Esqueceu sua senha?",
    errorRecovery: "Erro na recuperação de senha, por favor verifique o código fornecido",

    /** FOOTER */
    msgFooterContact: "CONTATO",

    msgFooterGr: "Financiado pela União Europeia. No entanto, as opiniões expressas são exclusivamente dos autores e não refletem necessariamente as da União Europeia. Nem a União Europeia nem a autoridade concedente podem ser responsabilizadas por elas. Referência do Acordo de Chamada e Concessão: SOCPL-2022-SOC-DIALOG-01 (Projeto 101102389)",
    msgCopyright: "Copyright&copy;2025 AMBIT. Todos os direitos reservados",

    msgFooterLegal: "Aviso legal",
    msgFooterPrivacy: "Privacidade",
    msgFooterCookies: "Política de Cookies",

    /** PROGRESS VALUES */
    msgProgress0: "Estratégias de design circular",

    /** COMPANY SIZES */
    msgCompanySize: "Tamanho da empresa",
    msgCompanySize1: "Menos de 10 funcionários",
    msgCompanySize2: "10-30 funcionários",
    msgCompanySize3: "30-50 funcionários",
    msgCompanySize4: "Mais de 50 funcionários",

    /** PRODUCT TYPES */
    msgProductType: "Tipo de produtos que você fabrica",
    msgProductType1: "Estofados",
    msgProductType2: "Colchões",
    msgProductType3: "Bases de estofados, canapé, bases de cama",
    msgProductType4: "Subcontratado (estruturas, usinagem, envernizamento, etc.)",
    msgProductType5: "Serviços (logística especializada, etc.)",
    msgProductType6: "Móveis de painel (melamina, lâmina, verniz, etc.)",
    msgProductType7: "Móveis de madeira",
    msgProductType8: "Cadeiras",
    msgProductType9: "Móveis de escritório",
    msgProductType10: "Móveis para espaços e usos públicos",
    msgProductType11: "Portas, janelas e produtos de carpintaria",
    msgProductType12: "Instalações personalizadas (lojas, bibliotecas, restaurantes, empresas profissionais, etc.)",
    msgProductType13: "Iluminação",
    msgProductType14: "Revestimentos e pisos",
    msgProductType15: "Têxteis",
    msgProductType16: "Decorações",

    /* COUNTRIES */
    msgCountry: "País",
    msgAfghanistan: "Afeganistão",
    msgAlbania: "Albânia",
    msgAlgeria: "Argélia",
    msgAmericanSamoa: "Samoa Americana",
    msgAndorra: "Andorra",
    msgAngola: "Angola",
    msgAnguilla: "Anguila",
    msgAntarctica: "Antártida",
    msgAntiguaandBarbuda: "Antígua e Barbuda",
    msgArgentina: "Argentina",
    msgArmenia: "Armênia",
    msgAruba: "Aruba",
    msgAustralia: "Austrália",
    msgAustria: "Áustria",
    msgAzerbaijan: "Azerbaijão",
    msgBahamas: "Bahamas",
    msgBahrain: "Bahrein",
    msgBangladesh: "Bangladesh",
    msgBarbados: "Barbados",
    msgBelarus: "Bielorrússia",
    msgBelgium: "Bélgica",
    msgBelize: "Belize",
    msgBenin: "Benin",
    msgBermuda: "Bermudas",
    msgBhutan: "Butão",
    msgBolivia: "Bolívia",
    msgBosniaHerzegovina: "Bósnia e Herzegovina",
    msgBotswana: "Botsuana",
    msgBouvetIsland: "Ilha Bouvet",
    msgBrazil: "Brasil",
    msgBritishIndian: "Território Britânico do Oceano Índico",
    msgBrunei: "Brunei",
    msgBulgaria: "Bulgária",
    msgBurkinaFaso: "Burquina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Camboja",
    msgCameroon: "Camarões",
    msgCanada: "Canadá",
    msgCapeVerde: "Cabo Verde",
    msgCaymanIslands: "Ilhas Cayman",
    msgCentralAfrican: "República Centro-Africana",
    msgChad: "Chade",
    msgChile: "Chile",
    msgChina: "China",
    msgChristmasIsland: "Ilha Christmas",
    msgCocosIslands: "Ilhas Cocos (Keeling)",
    msgColombia: "Colômbia",
    msgComoros: "Comores",
    msgCongo: "Congo",
    msgRepublicCongo: "República Democrática do Congo",
    msgCookIslands: "Ilhas Cook",
    msgCostaRica: "Costa Rica",
    msgIvoryCoast: "Costa do Marfim",
    msgCroatia: "Croácia",
    msgCuba: "Cuba",
    msgCyprus: "Chipre",
    msgCzechRepublic: "República Tcheca",
    msgDenmark: "Dinamarca",
    msgDjibouti: "Djibuti",
    msgDominica: "Dominica",
    msgDominicanRepublic: "República Dominicana",
    msgEastTimor: "Timor Leste",
    msgEcuador: "Equador",
    msgEgypt: "Egito",
    msgEngland: "Inglaterra",
    msgElSalvador: "El Salvador",
    msgEquatorialGuinea: "Guiné Equatorial",
    msgEritrea: "Eritreia",
    msgEstonia: "Estônia",
    msgEthiopia: "Etiópia",
    msgFalklandIslands: "Ilhas Malvinas",
    msgFaroeIslands: "Ilhas Faroé",
    msgFijiIslands: "Ilhas Fiji",
    msgFinland: "Finlândia",
    msgFrance: "França",
    msgFrenchGuiana: "Guiana Francesa",
    msgFrenchPolynesia: "Polinésia Francesa",
    msgFrenchSouthern: "Territórios Franceses do Sul",
    msgGabon: "Gabão",
    msgGambia: "Gâmbia",
    msgGeorgia: "Geórgia",
    msgGermany: "Alemanha",
    msgGhana: "Gana",
    msgGibraltar: "Gibraltar",
    msgGreece: "Grécia",
    msgGreenland: "Groelândia",
    msgGrenada: "Granada",
    msgGuadeloupe: "Guadalupe",
    msgGuam: "Guam",
    msgGuatemala: "Guatemala",
    msgGuernsey: "Guernsey",
    msgGuinea: "Guiné",
    msgGuineaBissau: "Guiné-Bissau",
    msgGuyana: "Guiana",
    msgHaiti: "Haiti",
    msgHeardMcDonald: "Ilhas Heard e McDonald",
    msgHolySee: "Santa Sé (Vaticano)",
    msgHonduras: "Honduras",
    msgHongKong: "Hong Kong",
    msgHungary: "Hungria",
    msgIceland: "Islândia",
    msgIndia: "Índia",
    msgIndonesia: "Indonésia",
    msgIran: "Irã",
    msgIraq: "Iraque",
    msgIreland: "Irlanda",
    msgIsrael: "Israel",
    msgIsleMan: "Ilha de Man",
    msgItaly: "Itália",
    msgJamaica: "Jamaica",
    msgJapan: "Japão",
    msgJersey: "Jersey",
    msgJordan: "Jordânia",
    msgKazakhstan: "Cazaquistão",
    msgKenya: "Quênia",
    msgKiribati: "Quiribati",
    msgKuwait: "Kuwait",
    msgKyrgyzstan: "Quirguistão",
    msgLaos: "Laos",
    msgLatvia: "Letônia",
    msgLebanon: "Líbano",
    msgLesotho: "Lesoto",
    msgLiberia: "Libéria",
    msgLibyanJamahiriya: "Jamahiriya Árabe Líbia",
    msgLiechtenstein: "Liechtenstein",
    msgLithuania: "Lituânia",
    msgLuxembourg: "Luxemburgo",
    msgMacao: "Macau",
    msgNorthMacedonia: "Macedônia do Norte",
    msgMadagascar: "Madagascar",
    msgMalawi: "Malawi",
    msgMalaysia: "Malásia",
    msgMaldives: "Maldivas",
    msgMali: "Mali",
    msgMalta: "Malta",
    msgMarshallIslands: "Ilhas Marshall",
    msgMartinique: "Martinica",
    msgMauritania: "Mauritânia",
    msgMauritius: "Maurício",
    msgMayotte: "Mayotte",
    msgMexico: "México",
    msgMicronesia: "Micronésia, Estados Federados",
    msgMoldova: "Moldávia",
    msgMonaco: "Mônaco",
    msgMongolia: "Mongólia",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Montenegro",
    msgMorocco: "Marrocos",
    msgMozambique: "Moçambique",
    msgMyanmar: "Myanmar",
    msgNamibia: "Namíbia",
    msgNauru: "Nauru",
    msgNepal: "Nepal",
    msgNetherlands: "Países Baixos",
    msgNetherlandsAntilles: "Antilhas Neerlandesas",
    msgNewCaledonia: "Nova Caledônia",
    msgNewZealand: "Nova Zelândia",
    msgNicaragua: "Nicarágua",
    msgNiger: "Níger",
    msgNigeria: "Nigéria",
    msgNiue: "Niue",
    msgNorfolkIsland: "Ilha Norfolk",
    msgNorthKorea: "Coreia do Norte",
    msgNorthernIreland: "Irlanda do Norte",
    msgNorthernMariana: "Ilhas Marianas do Norte",
    msgNorway: "Noruega",
    msgOman: "Omã",
    msgPakistan: "Paquistão",
    msgPalau: "Palau",
    msgPalestine: "Palestina",
    msgPanama: "Panamá",
    msgPapua: "Papua Nova Guiné",
    msgParaguay: "Paraguai",
    msgPeru: "Peru",
    msgPhilippines: "Filipinas",
    msgPitcairn: "Pitcairn",
    msgPoland: "Polônia",
    msgPortugal: "Portugal",
    msgPuertoRico: "Porto Rico",
    msgQatar: "Catar",
    msgReunion: "Reunião",
    msgRomania: "Romênia",
    msgRussianFederation: "Federação Russa",
    msgRwanda: "Ruanda",
    msgSaintHelena: "Santa Helena",
    msgSaintKitts: "São Cristóvão e Nevis",
    msgSaintLucia: "Santa Lúcia",
    msgSaintPierre: "São Pedro e Miquelão",
    msgSaintVincent: "São Vicente e Granadinas",
    msgSamoa: "Samoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "São Tomé e Príncipe",
    msgSaudiArabia: "Arábia Saudita",
    msgScotland: "Escócia",
    msgSenegal: "Senegal",
    msgSerbia: "Sérvia",
    msgSeychelles: "Seicheles",
    msgSierraLeone: "Serra Leoa",
    msgSingapore: "Singapura",
    msgSlovakia: "Eslováquia",
    msgSlovenia: "Eslovênia",
    msgSolomonIslands: "Ilhas Salomão",
    msgSomalia: "Somália",
    msgSouthAfrica: "África do Sul",
    msgSouthSandwich: "Geórgia do Sul e Ilhas Sandwich do Sul",
    msgSouthKorea: "Coreia do Sul",
    msgSouthSudan: "Sudão do Sul",
    msgSpain: "Espanha",
    msgSriLanka: "Sri Lanka",
    msgSudan: "Sudão",
    msgSuriname: "Suriname",
    msgSvalbardJan: "Svalbard e Jan Mayen",
    msgSwaziland: "Suazilândia",
    msgSweden: "Suécia",
    msgSwitzerland: "Suíça",
    msgSyria: "Síria",
    msgTajikistan: "Tajiquistão",
    msgTanzania: "Tanzânia",
    msgThailand: "Tailândia",
    msgTimorLeste: "Timor-Leste",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinidad e Tobago",
    msgTunisia: "Tunísia",
    msgTurkey: "Turquia",
    msgTurkmenistan: "Turcomenistão",
    msgTurksCaicos: "Ilhas Turcas e Caicos",
    msgTuvalu: "Tuvalu",
    msgUganda: "Uganda",
    msgUkraine: "Ucrânia",
    msgUnitedArabEmirates: "Emirados Árabes Unidos",
    msgUnitedKingdom: "Reino Unido",
    msgUnitedStates: "Estados Unidos",
    msgUnitedStatesMinor: "Ilhas Menores Distantes dos Estados Unidos",
    msgUruguay: "Uruguai",
    msgUzbekistan: "Uzbequistão",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venezuela",
    msgVietnam: "Vietnã",
    msgVirginIslandsBritish: "Ilhas Virgens Britânicas",
    msgVirginIslandsUS: "Ilhas Virgens dos EUA",
    msgWales: "País de Gales",
    msgWallisFutuna: "Wallis e Futuna",
    msgWesternSahara: "Sahara Ocidental",
    msgYemen: "Iémen",
    msgZambia: "Zâmbia",
    msgZimbabwe: "Zimbábue",
}

export default pt;